// src/components/dashboard/CopyTradeWidget/CopyTradeWidget.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { copyTradingService } from '../../../services/copyTradingService';
import './CopyTradeWidget.css';

const CopyTradeWidget = () => {
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);
  const [isCopying, setIsCopying] = useState(false);

  useEffect(() => {
    fetchStatus();
    const handler = () => fetchStatus();
    window.addEventListener('refreshCopyTrade', handler);
    return () => window.removeEventListener('refreshCopyTrade', handler);
  }, []);

  const fetchStatus = async () => {
    try {
      const [statusData, notifs] = await Promise.all([
        copyTradingService.getMyCopyStatus(),
        copyTradingService.getNotifications(true),
      ]);
      setIsCopying(statusData.following && statusData.relationship?.status === 'ACTIVE');
      setUnreadCount(Array.isArray(notifs) ? notifs.length : 0);
    } catch {
      // silent fail — widget is non-critical
    }
  };

  return (
    <div className="copy-widget-container">
      <button
        className={`copy-icon-button ${isCopying ? 'is-copying' : ''}`}
        onClick={() => navigate('/copy-trading')}
        title="Copy Trading"
      >
        {/* Copy / mirror icon — two overlapping arrows */}
        <div className="copy-symbol">
          <svg viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" className="copy-svg">
            {/* Left arrow (leader) */}
            <circle cx="8" cy="14" r="5" stroke="currentColor" strokeWidth="2" />
            {/* Right arrow (copier) */}
            <circle cx="20" cy="14" r="5" stroke="currentColor" strokeWidth="2" />
            {/* Bridge */}
            <path d="M13 14 H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            {/* Arrow tip right */}
            <path d="M13 11 L16 14 L13 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        {/* Active pulse ring when copying */}
        {isCopying && <span className="copy-active-ring" />}

        {/* Unread notification badge */}
        {unreadCount > 0 && (
          <span className="copy-badge">{unreadCount > 9 ? '9+' : unreadCount}</span>
        )}
      </button>
      <span className="widget-label">Copy Trade</span>
    </div>
  );
};

export default CopyTradeWidget;